import {SignalStoreDexieIDB} from './dexie-db';

export function setSignalStoreDexieIdbVersions(this: SignalStoreDexieIDB) {
	this.version(1)
		.stores({})
		.upgrade(async tx => {
			await tx.table(SignalStoreDexieIDB.SIGNAL_STORE_TABLE_NAME).clear();
		});

	this.version(2).stores({
		[SignalStoreDexieIDB.SIGNAL_STORE_TABLE_NAME]: 'storeName',
	});

	/* ----------------------------- Latest Version ----------------------------- */
	this.version(4).stores({
		[SignalStoreDexieIDB.SIGNAL_STORE_TABLE_NAME]: 'storeName',
	});

	return this.verno;
}
